const PAGE_SIZE = 500;

/**
 * For an RTK Query queryFn: pages through POST <url> (an admin list endpoint) until every
 * item is loaded. Returns { data: items } or the first { error }.
 */
export const fetchAllPages = async (baseQuery, url) => {
	const items = [];
	for (let page = 0; ; page += 1) {
		const result = await baseQuery({ url, method: 'POST', body: { page, pageSize: PAGE_SIZE } });
		if (result.error) {
			return { error: result.error };
		}
		items.push(...result.data.items);
		if (items.length >= result.data.total || !result.data.items.length) {
			return { data: items };
		}
	}
};
